import React, { useRef } from 'react';
import type { EmojiProvider } from '@atlaskit/emoji';
import { getEmojiProvider } from '@atlassian/jira-common-atlaskit-services/src/emoji.tsx';
import type { FieldOperations } from '@atlassian/jira-common-rest/src/internal/simplified/1.0/projects/id/issuetypes/id/types.tsx';
import type { ProjectKey } from '@atlassian/jira-shared-types/src/general.tsx';
import type { FieldConfigurationComponentProps } from '../../../../types.tsx';
import { TaskAndDecisionProvider } from '../../../../services/task-decision-provider.tsx';
import ProjectSettingsProjectMentionProvider from './mentions/project-settings-project-mention-provider.tsx';
import { MultilineView } from './view.tsx';

function getProjectMentionProvider(projectKey: ProjectKey) {
	return Promise.resolve(
		new ProjectSettingsProjectMentionProvider(
			'',
			projectKey,
			null, // projectType is never used in the ProjectMentionProvider
		),
	);
}

export const MultilineFieldConfiguration = (props: FieldConfigurationComponentProps) => {
	const mentionProvider = useRef(getProjectMentionProvider(props.projectKey));
	const emojiProvider = useRef<Promise<EmojiProvider> | undefined>(getEmojiProvider() ?? undefined);

	const taskAndDecisionProvider = useRef<Promise<TaskAndDecisionProvider>>(
		Promise.resolve(new TaskAndDecisionProvider()),
	);

	return (
		<MultilineView
			{...props}
			mentionProvider={mentionProvider.current}
			emojiProvider={emojiProvider.current}
			taskDecisionProvider={taskAndDecisionProvider.current}
		/>
	);
};

export const isExpandable = (operations: FieldOperations): boolean =>
	operations.canModifyDefaultValue;
